/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum SubjectTypeEnum {
    F = 'F',
    D = 'D',
    S = 'S',
    C = 'C'
}

export function SubjectTypeEnumFromJSON(json: any): SubjectTypeEnum {
    return SubjectTypeEnumFromJSONTyped(json, false);
}

export function SubjectTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubjectTypeEnum {
    return json as SubjectTypeEnum;
}

export function SubjectTypeEnumToJSON(value?: SubjectTypeEnum | null): any {
    return value as any;
}

